import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler } from 'chart.js';
import withStyles from '@mui/styles/withStyles';
import { stringIsNullOrEmpty } from '../../utils/strings';
import Spinner from '../loading/Spinner';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

export default withStyles({})(({ variant, data, label, loading }) => {
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `bar-fill--${variant}`;

    const myData = {
        labels: data && data.map(e => `${e.label}`),
        datasets: [
            {
                data: data && data.map(e => e.value),
                label: label || 'Amount',
                // fill: false,
                backgroundColor: '#7d9cc422',
                borderColor: '#7d9cc4'
            }
        ]
    };

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            {(!!loading && <Spinner />) || (
                <Line
                    className={cssVariant}
                    options={{
                        maintainAspectRatio: false,
                        plugins: {
                            tooltip: { enabled: true },
                            legend: {
                                position: 'bottom',
                                labels: { color: '#000000', font: { size: 16 } }
                            }
                        }
                    }}
                    height={400}
                    data={myData}
                />
            )}
        </div>
    );
});
